<template>
  <div class="simple-dialog-mask" v-if="value" @click="handleClose">
    <div class="simple-dialog-content" @click.stop>
      <div class="simple-dialog-body">
        <div class="simple-dialog-text">{{ content }}</div>
      </div>
      <div class="simple-dialog-footer">
        <button class="simple-dialog-btn" @click="handleConfirm">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: "",
    },
    confirmText: {
      type: String,
      default: "确认",
    },
  },
  methods: {
    handleClose() {
      this.$emit("input", false);
    },
    handleConfirm() {
      this.$emit("input", false);
      window.location.reload();
    },
  },
};
</script>

<style>
.simple-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.simple-dialog-content {
  width: 17.5rem;
  background: #fff;
  border-radius: 0.5rem;
  overflow: hidden;
}

.simple-dialog-body {
  padding: 1.5rem;
  text-align: center;
}

.simple-dialog-text {
  font-size: 0.95rem;
  color: #111e36;
  line-height: 1.6;
}

.simple-dialog-footer {
  padding: 1rem;
  border-top: 1px solid #f0f0f0;
}

.simple-dialog-btn {
  width: 100%;
  height: 2.5rem;
  background: linear-gradient(90deg, #ff8c3b 0%, #ff6600 100%);
  color: #fff;
  font-size: 1rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/simple-dialog.vue